/* 詳細画面 保証人 */
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { useCallApi } from '../../hooks/CallApi';
import useFetchReceptionData from '../../hooks/FetchReceptionData';
import ContentInquiry from './ContentInquiry';
import ContentInquiryFinal from './ContentInquiryFinal';
import ContractContentConfirm from './ContractContentConfirm';
import { KDANKGM05010A01, KDANKGM05010A02 } from '../../const/api_modules';
import ExaminationChange from './ExaminationChange';
import ContentInquiryGuarantorDisagreement from './ContentInquiryGuarantorDisagreement';
import SignatureComplete from '../applicant/SignatureComplete';
import { FixedValuesContext } from '../../context/FixedValues';
import AfterLoanApplication from '../applicant/AfterLoanApplication';
import useLazyLoad from '../../hooks/LazyLoad';
import { hasErrorMessage } from '../../Common';
import BorrowingConsultationContentInquiry from './BorrowingConsultationContentInquiry';
import BorrowingConsultationContentInquiryGuarantorDisagreement from './BorrowingConsultationContentInquiryGuarantorDisagreement';
import BorrowingConsultationContentInquiryFinal from './BorrowingConsultationContentInquiryFinal';
import BorrowingConsultationContentInquiryGuarantor from './BorrowingConsultationContentInquiryGuarantor';

const App: React.FC = () => {
  // ローディング画面制御
  const [is_loading, setIsLoading] = useState(false);
  const {
    // ヘッダ
    label,
    guide_text,
    step_navigation,
    display_reception_cd,
    display_status,
    // 詳細画面情報
    parent_shelfs,
    child_shelfs,
    contents,
    // 固定パラメータ
    status_name,
    status_code,
    loan_type,
    reception_id,
    reception_cd,
    reception_sub_cd,
    ident_lv1_cd,
    ident_lv2_cd,
    ident_lv3_cd,
    ja_name,
    opened_mypage,
    is_staff,
    applied,
    is_change,
    has_debtor,
    is_disagree,
    change_request_message,
    guarantors_num,
    sign_info,
    is_signed,
    agreements,
    guarantor_info,
    review_approval_status,
    is_checked_contract_document,
    review_approval_status_name,
    review_message,
    agreement_info,
    has_loan_approval,
    is_implement_online_identification,
    is_guarantor_agreement,
    online_identification_modal_open,
    is_change_request_message_registered,
    is_secured,
    is_unsecured,
    is_agricultural_modernization_funds,
    is_corporate_user,
    // ファイルアップローダ
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    // お客様へのお知らせ
    info_notice_contract_confirm,
    // 辞退ボタンの活性フラグ
    is_active_decline_btn,
    is_signer,
    // ディスパッチ
    setParentShelfs,
    setChildShelfs,
    setContents,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    setDisplayStatus,
    setIsGuarantorAgreement,
    // 関数
    moveStepNav,
    setIsImplementOnlineIdentification,
    setOnlineIdentificationModalOpen,
  } = useFetchReceptionData(setIsLoading);

  // API呼び出し処理
  const { setShowErrorNav, show_error_nav, api_response_detail, requestModule } = useCallApi(
    child_shelfs,
    contents,
    setContents,
    setChildShelfs,
    reception_id,
    reception_cd,
    status_code,
    is_staff,
    setIsLoading,
    guarantor_info,
    setOnlineIdentificationModalOpen
  );

  // 書類画像の遅延ロード
  useLazyLoad(
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    is_loading,
    status_code
  );

  // エラーナビゲーション制御
  const [has_valid_error, setHasValidError] = useState(false);

  useEffect(() => {
    setHasValidError(hasErrorMessage(contents));
  }, [contents]);

  return (
    <Router>
      {/* TODO sakuma 固定値はすべてこちらのContextを見るように修正する */}
      <FixedValuesContext.Provider
        value={{
          has_loan_approval: has_loan_approval,
          has_review_approval_status: review_approval_status,
        }}
      >
        <Switch>
          {/* KWANKGM02060_借入相談内容照会 */}
          <Route exact path="/reception/:reception_cd/:reception_id/1250">
            <BorrowingConsultationContentInquiry
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              agreements={agreements}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={requestModule}
              is_loading={is_loading}
              is_disagree={is_disagree}
              setShowErrorNav={setShowErrorNav}
              is_guarantor_agreement={is_guarantor_agreement}
              setIsGuarantorAgreement={setIsGuarantorAgreement}
            />
          </Route>
          {/* KWANKGM02050_借入相談同意不同意（受付完了） */}
          {/* 同意の場合 */}
          <Route exact path="/reception/:reception_cd/:reception_id/1250/agree">
            <BorrowingConsultationContentInquiryFinal
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
            />
          </Route>
          {/* 不同意の場合 */}
          <Route exact path="/reception/:reception_cd/:reception_id/1250/disagree">
            <BorrowingConsultationContentInquiryFinal
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
            />
          </Route>
          {/* KWANKGM02060_借入相談内容照会(ステータス：1260) */}
          <Route exact path="/reception/:reception_cd/:reception_id/1260">
            <BorrowingConsultationContentInquiryGuarantorDisagreement
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              agreements={agreements}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={requestModule}
              is_loading={is_loading}
              is_disagree={is_disagree}
            />
          </Route>
          {/* 借入相談変更中、借入申込、借入申込変更 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(1200|2100|2300|2200)">
            <ExaminationChange
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              label={label}
              reception_cd={reception_cd}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              display_status={display_status}
              is_loading={is_loading}
            />
          </Route>
          {/* 借入相談以降の参照画面(ステータス：1300、1400、1500、91550) */}
          <Route exact path="/reception/:reception_cd/:reception_id/(1300|1400|1500|91550)">
            <BorrowingConsultationContentInquiryGuarantor
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={requestModule}
              is_loading={is_loading}
            />
          </Route>
          {/* KWANKGM04050_借入申込内容照会画面 */}
          <Route exact path="/reception/:reception_cd/:reception_id/2400">
            <ContentInquiry
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_sub_cd={reception_sub_cd}
              agreements={agreements}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={requestModule}
              is_loading={is_loading}
              is_disagree={is_disagree}
              setShowErrorNav={setShowErrorNav}
              is_implement_online_identification={is_implement_online_identification}
              setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
              is_guarantor_agreement={is_guarantor_agreement}
              setIsGuarantorAgreement={setIsGuarantorAgreement}
              modal_open={online_identification_modal_open}
              setModalnOpen={setOnlineIdentificationModalOpen}
              is_change_request_message_registered={is_change_request_message_registered}
              change_request_message={change_request_message}
              is_corporate_user={is_corporate_user}
            />
          </Route>
          {/* KWANKGM04060_借入申込同意不同意（受付完了） */}
          {/* 同意の場合 */}
          <Route exact path="/reception/:reception_cd/:reception_id/2400/agree">
            <ContentInquiryFinal
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
            />
          </Route>
          {/* 不同意の場合 */}
          <Route exact path="/reception/:reception_cd/:reception_id/2400/disagree">
            <ContentInquiryFinal
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
            />
          </Route>
          {/* KWANKGM04050_借入申込内容照会画面(ステータス2500) */}
          <Route exact path="/reception/:reception_cd/:reception_id/2500">
            <ContentInquiryGuarantorDisagreement
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_sub_cd={reception_sub_cd}
              agreements={agreements}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              setDisplayStatus={(flag: boolean) => setDisplayStatus(flag)}
              moveStepNav={() => moveStepNav(0)}
              requestModule={requestModule}
              is_loading={is_loading}
              is_disagree={is_disagree}
            />
          </Route>
          {/* 借入申込以降の参照画面 */}
          <Route
            exact
            path="/reception/:reception_cd/:reception_id/(2600|2700|2900|3000|3100|3400|93050)"
          >
            <AfterLoanApplication
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_sub_cd={reception_sub_cd}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              callApi={requestModule}
              is_loading={is_loading}
              is_staff={is_staff}
            />
          </Route>
          {/* KDANKGM05010_契約書内容確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(3500|3600|3700|3800|3900)">
            <ContractContentConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_sub_cd={reception_sub_cd}
              sign_info={sign_info}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              is_signed={guarantor_info.is_signed}
              handleDecline={() => requestModule(KDANKGM05010A01)}
              handleExecution={() => requestModule(KDANKGM05010A02)}
              callApi={requestModule}
              is_loading={is_loading}
              is_checked_contract_document={is_checked_contract_document}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              info_notice={info_notice_contract_confirm}
              is_active_decline_btn={is_active_decline_btn}
              is_signer={is_signer}
            />
          </Route>
          {/* KWANKGM00190_案件詳細（マイページ） */}
          <Route exact path="/reception/:reception_cd/:reception_id/4100">
            <SignatureComplete
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_id={reception_id}
              reception_cd={reception_cd}
              reception_sub_cd={reception_sub_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              status_code={status_code}
              is_staff={is_staff}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              agreement_info={agreement_info}
              sign_info={sign_info}
              is_signer={is_signer}
            />
          </Route>
        </Switch>
      </FixedValuesContext.Provider>
    </Router>
  );
};

if (document.getElementById('template-guarantor')) {
  ReactDOM.render(<App />, document.getElementById('template-guarantor'));
}
